import { getData, postData, putData, deleteData } from './ajax';
import { ADD_ARTIST, UPDATE_ARTIST, REMOVE_ARTIST, FETCH_ARTIST, FETCH_ARTISTS, ARTIST_ERROR } from './types';


export function clearErrors() {
	return (dispatch) => {
		dispatch({ type: 'clear_errors' });
	};
}